import React, { memo } from "react";
import { Stack, Typography, CardContent, Card, Box, Button, Icon } from "investira.react.components";
import { Link } from "react-router-dom";
import { displays } from "investira.react.lib";
import { PessoaImage } from "../../../../components/molecules";
import utils from "../../../../utils";
import { validators } from "investira.sdk";
const GestorAdministrador = memo(props => {
  const {
    pessoa
  } = props;
  if (validators.isNull(pessoa.adm_pessoa_id) || validators.isNull(pessoa.gestor_pessoa_id)) {
    return null;
  }
  return <Stack flexGrow={1}>
      <Box sx={{
      display: "grid",
      gridTemplateColumns: {
        xs: "repeat(1, 1fr)",
        lg: "repeat(2, 1fr)"
      },
      gap: 1.5
    }}>
        <Stack flexGrow={1}>
          <Card>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={3} mb={2}>
                <Stack>
                  <Typography variant="caption" color="textPrimary">
                    <b>Gestor</b>
                  </Typography>
                </Stack>
                <Stack flexGrow="1"></Stack>
                {pessoa.gestor_pessoa_id && <Stack>
                    <Button component={Link} title={pessoa.gestor?.pessoa_fantasia} endIcon={<Icon iconName="arrow-next" size={12} />} size="small" to={`/empresas/${pessoa.gestor_pessoa_id}`} sx={{
                  px: 2,
                  textTransform: "capitalize"
                }}>
                      {`${utils.typo.shortname(pessoa.gestor?.pessoa_fantasia || "", 20)}`}
                    </Button>
                  </Stack>}
              </Stack>
              <Stack direction="row" alignItems="center" spacing={3}>
                <Stack>
                  <PessoaImage logoPessoaId={pessoa.logo_pessoa_id} alt={pessoa.pessoa} hasLogo={pessoa.logo_ok} size={36} />
                </Stack>
                <Stack>
                  <Typography variant="caption" color="textPrimary">
                    Nome Fantasia
                  </Typography>
                  <Typography variant="caption" color="textPrimary" sx={{
                  fontWeight: 600
                }}>
                    {pessoa.gestor?.pessoa_fantasia || "--"}
                  </Typography>
                </Stack>
                <Stack>
                  <Typography variant="caption" color="textPrimary">
                    CNPJ
                  </Typography>
                  <Typography variant="caption" color="textPrimary" sx={{
                  fontWeight: 600
                }}>
                    {displays.cnpj(pessoa.gestor?.cnpj) || "--"}
                  </Typography>
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Stack>

        <Stack flexGrow={1}>
          <Card>
            <CardContent>
              <Stack direction="row" alignItems="center" spacing={3} mb={2}>
                <Stack>
                  <Typography variant="caption" color="textPrimary">
                    <b>Administrador</b>
                  </Typography>
                </Stack>
                <Stack flexGrow="1"></Stack>
                {pessoa.adm_pessoa_id && <Stack>
                    <Button component={Link} title={pessoa.adm?.pessoa_fantasia} endIcon={<Icon iconName="arrow-next" size={12} />} size="small" to={`/empresas/${pessoa.adm_pessoa_id}`} sx={{
                  px: 2,
                  textTransform: "capitalize"
                }}>
                      {`${utils.typo.shortname(pessoa.adm?.pessoa_fantasia || "", 20)}`}
                    </Button>
                  </Stack>}
              </Stack>
              <Stack direction="row" alignItems="center" spacing={3}>
                <Stack>
                  <PessoaImage logoPessoaId={pessoa.adm?.logo_pessoa_id} alt={pessoa.adm?.pessoa_fantasia} hasLogo={pessoa.adm?.logo_ok || false} size={36} />
                </Stack>
                <Stack>
                  <Typography variant="caption" color="textPrimary">
                    Nome Fantasia
                  </Typography>
                  <Typography variant="caption" color="textPrimary" sx={{
                  fontWeight: 600
                }}>
                    {pessoa.adm?.pessoa_fantasia || "--"}
                  </Typography>
                </Stack>
                <Stack>
                  <Typography variant="caption" color="textPrimary">
                    CNPJ
                  </Typography>
                  <Typography variant="caption" color="textPrimary" sx={{
                  fontWeight: 600
                }}>
                    {displays.cnpj(pessoa.adm?.cnpj) || "--"}
                  </Typography>
                </Stack>
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </Stack>;
});
export default GestorAdministrador;
